<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Agent Password Form</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <md-layout md-gutter>
                <b-col md="3">
                  <label>
                    Agent Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    disabled
                    :formatter="capitalizeAll"
                    id="agentName"
                    name="agentName"
                    v-model="agentUserForm.agentName"
                    placeholder="Please Enter Client Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!agentUserForm.agentName">
                    {{ errorList.agentName }}
                  </span>
                </b-col>
                <b-col md="6">
                  <label>
                    Common Email
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    disabled
                    :formatter="capitalizeAll"
                    id="emailId"
                    name="emailId"
                    v-model="agentUserForm.emailId"
                    placeholder="Please Enter Email ID"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!agentUserForm.emailId">
                    {{ errorList.emailId }}
                  </span>
                </b-col>
                <b-col md="3">
                  <b-row>
                    <b-col sm="8">
                      <label>
                        Common Password
                        <span class="error">*</span>
                      </label>
                      <b-form-input
                        :disabled="agentUserForm.agntColoaderId ? false : true"
                        :formatter="capitalizeAll"
                        id="password"
                        name="password"
                        v-model="agentUserForm.agent_pass"
                        placeholder="Please Enter Password"
                        type="text"
                        @input="PasswordChangeFlag()"
                      ></b-form-input>
                      <span class="error" v-if="!agentUserForm.agent_pass">
                        {{ errorList.agent_pass }}
                      </span>
                    </b-col>
                    <b-col sm="4" class="mt-5">
                      <b-button style="font-size: 0.675rem" @click="generatePassword"
                        >Generate</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="2">
                  <b-button
                    style="font-size: 0.675rem"
                    size="sm"
                    class="text-left"
                    :variant="'info'"
                    @click="ActiveAccordion(UserActiveStatus)"
                    >Show Users</b-button
                  >
                </b-col>

                <b-col cols="12">
                  <table class="table table-sm table-bordered mt-2">
                    <tbody style="background: white">
                      <tr
                        v-if="
                          agentUserForm.agent_user_list.length > 0 || UserActiveStatus
                        "
                      >
                        <th scope="col" style="width: 5px">SN.</th>
                        <th scope="col" style="width: 200px">User Name</th>
                        <th scope="col" style="width: 180px">Email</th>
                        <th scope="col" style="width: 180px">Password</th>
                        <th scope="col" style="width: 5px">
                          Actions
                          <b-button @click="addAgentUser()" size="sm">
                            <i class="fa fa-plus-circle ml-1"></i>
                          </b-button>
                        </th>
                      </tr>
                      <tr
                        v-for="(item, index) in agentUserForm.agent_user_list"
                        :key="index"
                      >
                        <th scope="row">{{ index + 1 }}.</th>
                        <td>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="item.user_name"
                            type="text"
                            placeholder="Enter User Name"
                          ></b-form-input>
                          <span class="error" v-if="item.user_name_err ? true : false">{{
                            item.user_name_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="item.user_email"
                            type="text"
                            placeholder="Enter User EMail"
                          ></b-form-input>
                          <span class="error" v-if="item.user_email_err ? true : false">{{
                            item.user_email_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="item.user_pass"
                            type="text"
                            placeholder="Enter User Password"
                          ></b-form-input>
                          <span class="error" v-if="item.user_pass_err ? true : false">{{
                            item.user_pass_err
                          }}</span>
                        </td>
                        <td>
                          <b-button
                            v-if="index > 0"
                            size="sm"
                            @click="removeAgentUser(index)"
                          >
                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </md-layout>
            </div>
            <hr />
            <div>
              <b-col md="3"></b-col>
              <b-col md="3">
                <b-button
                  :disabled="isLoading?true:false"
                  size="sm"
                  class="pull-right"
                  style="margin:left:5px;font-size: 0.675rem"
                  variant="primary"
                  @click="addAgentUserForm"
                  >Save</b-button
                >

                <b-button
                  v-if="
                    (agentUserForm.fk_agent_id &&
                      agentUserForm.is_approval_mail_send == 0) ||
                    agentUserForm.is_approval_mail_send == 2
                  "
                  variant="primary"
                  style="font-size: 0.675rem"
                  @click="sendAgentMail(agentUserForm)"
                  id="addButtonLoader"
                  size="sm"
                  >Send Mail</b-button
                >
              </b-col>
              <b-col md="3"></b-col>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../../helper/collection";
import ClientUserService from "../../../services/ClientUserService.js";

export default {
  beforeMount() {
    // alert(this.$route.params.agntColoaderId)
    if (this.$route.params.agntColoaderId > 0) {
      this.getSingleAgentUser(this.$route.params.agntColoaderId);
    } else {
      this.generatePassword();
    }
    if (globalPermissionStatus("Main Master") != "Disabled") {
      this.$sessionsStorage.set(
        "PermissionStatus",
        globalPermissionStatus("Main Master")
      );
      this.$store.dispatch(
        "setCurrentRoute",
        "/agent/user/upsertAgentUser/" + this.$route.params.agntColoaderId
      );
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      UserActiveStatus: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      agentUserForm: {
        fk_agent_id: this.$route.params.agntColoaderId,
        agentName: "",
        emailId: "",
        contactNumber: "",
        agent_pass: "",
        admin_agent_pass: "",
        agent_user_list: [],
        passwordFlag: false,
        admin_agent_pass_count: 0,
        is_approval_mail_send: 0,
      },
      agentUserFormError: [
        "Please Enter Agent Name",
        "Please Enter Email",
        "Please Enter Password",
      ],
      errorList: {
        agentName: "",
        emailId: "",
        agent_pass: "",
      },
      selectDateFormat,

      isLoading: false,
      validate: false,

      docURL: URL_BASE_DOC,
      validateAgentUser: true,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleClientUser() {
      return this.agentUserForm.fk_agent_id != "" ? true : false;
    },
  },
  methods: {
    generatePassword() {
      const length = 12;
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.agentUserForm.agent_pass = result;
    },
    goBack() {
      window.history.go(-1);
    },
    setAgentUserDetails(item, agntColoaderId) {
      agntColoaderId =
        agntColoaderId && !isNaN(agntColoaderId) ? parseInt(agntColoaderId) : 0;
      if (agntColoaderId > 0) {
        let agentUserDetails = item;

        this.agentUserForm = {
          fk_agent_id: this.$route.params.agntColoaderId,
          agentName: agentUserDetails.agentName,
          emailId: agentUserDetails.emailId,
          agent_pass: agentUserDetails.agent_pass,
          admin_agent_pass: agentUserDetails.admin_agent_pass,
          agent_user_list: agentUserDetails.agent_user_list,
          passwordFlag: false,
          contactNumber: agentUserDetails.contactNumber,
          admin_agent_pass_count: agentUserDetails.admin_agent_pass_count,
          is_approval_mail_send: agentUserDetails.is_approval_mail_send,
        };
      } else {
        this.agentUserForm = {
          fk_agent_id: this.$route.params.agntColoaderId,
          agentName: "",
          emailId: "",
          agent_pass: "",
          admin_agent_pass: "",
          agent_user_list: [],
          passwordFlag: false,
          contactNumber: "",
          admin_agent_pass_count: 0,
          is_approval_mail_send: 0,
        };
      }
      if (!this.agentUserForm.agent_pass) {
        this.generatePassword();
      }
    },
    validateAgent() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.agentUserForm[x] == "" ||
          this.agentUserForm[x] == undefined ||
          this.agentUserForm[x] == null
        ) {
          this.errorList[x] = this.agentUserFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    PasswordChangeFlag() {
      this.agentUserForm.passwordFlag = false;
      if (this.orgPass) {
        if (this.orgPass != this.agentUserForm.agent_pass) {
          this.agentUserForm.passwordFlag = true;
        }
      }
    },
    addAgentUserForm() {
      this.validateAgent();

      if (this.agentUserForm.agent_user_list.length > 0) {
        this.validateAgentUserDetail();
        console.log(this.validateAgentUser)
        if(this.validateAgentUser==false){
          this.validate=false;
        }
      }

      this.agentUserForm.TypeofAdd = "Agent User Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;
      let payload = {
        itemCode: "add_Agent_User_Details",
        agentUserForm: this.agentUserForm,
      };
      if (this.validate != false) {
        ClientUserService.getAllAgentUserList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.find == 1 || data.find == 2) {
              this.alert.content = data.MSG;
              this.getSingleAgentUser(this.$route.params.agntColoaderId);
            } else {
              this.alert.content = data.MSG;
            }
            if (data.flag == true) {
              this.$router.push({
                path: "/agent/user/upsertAgentUser/"+this.$route.params.agntColoaderId,
              });
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    sendAgentMail(item) {
      if (item.fk_agent_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Approval_Mail",
          agentUserForm: item,
        };
        ClientUserService.getAllAgentUserList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.agntColoaderId != "" && data.agntColoaderId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              if (data.flag == true) {
                this.$router.push({
                  path: "/agent/user/upsertAgentUser/",
                });
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },

    getSingleAgentUser(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_Agent",
        agntColoaderId: id,
      };
      ClientUserService.getAllAgentUserList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.setAgentUserDetails(
              data.singleAgent_User,
              data.singleAgent_User.agntColoaderId
            );
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single AgentUser Error: ", error);
        });
    },

    addAgentUser() {
      let obj = {
        agent_user_id: "",
        fk_agent_id: this.$route.params.agntColoaderId,
        user_name: "",
        user_name_err: "",
        user_email: "",
        user_email_err: "",
        user_pass: "",
        user_pass_err: "",
      };
      this.agentUserForm.agent_user_list.push(obj);
    },
    removeAgentUser(index) {
      this.agentUserForm.agent_user_list.splice(index, 1);
    },
    ActiveAccordion(ActiveStatus) {
      if (ActiveStatus == true) {
        this.UserActiveStatus = false;
      } else if (ActiveStatus == false) {
        this.UserActiveStatus = true;
      }
    },
    validateAgentUserDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.agentUserForm.agent_user_list;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].user_name == "") {
          this.agentUserForm.agent_user_list[j].user_name_err =
            "User Name " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.agentUserForm.agent_user_list[j].user_name_err = "";
          validate_new = true;
        }

        if (MainARR[j].user_email == "") {
          this.agentUserForm.agent_user_list[j].user_email_err =
            "User Email " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.agentUserForm.agent_user_list[j].user_email_err = "";
          validate_new = true;
        }

        if (MainARR[j].user_pass == "") {
          this.agentUserForm.agent_user_list[j].user_pass_err =
            "User Pass " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.agentUserForm.agent_user_list[j].user_pass_err = "";
          validate_new = true;
        }
      }
      if (errCount > 0) {
        this.validateAgentUser = false;
      } else {
        this.validateAgentUser = true;
      }
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// upsertAgentUser.vue?1a5fa36f